import ToggleField from '../../../Components/ToggleField';
import TextInput from '../../../Components/TextInput';
import { FormField } from '../../../Components/FormField';
import { ErrorMessage, Form, Formik } from 'formik';
import SidebarField from '../../../Components/SidebarField';
import Button from '../../../Components/Button';
import { CategoryApi, SubCategoryApi } from '../../../App/api/menu.apis';
import { toast } from 'react-toastify';
import LoaderContext from '../../../Components/loader/index'
import { useContext, useEffect, useState } from 'react';
import SelectDropdown from '../../../Components/Dropdown/SelectDropdown';
import { subcategorySchema } from './subcategory.ValidationSchema';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ImagePreview from '../../../Components/ImagePreview';

function AddSubCategory({currentItems,getAllData, open, handleClose,}) {
    const [categories, setCategories] = useState([]);  
    const [categoryType, setCategoryType] = useState("Ecommerce");  

  const initialValues = {
    name: currentItems?.name || "", 
    image: currentItems?.image || null,
    category:currentItems?.Category?._id||"",  
    categoryType:currentItems?.categoryType||"",          
    sequence: currentItems?.sequence || "",
    is_visible: currentItems?.is_visible ?? true, 
  };
   const [error, setError] = useState("");
    const handleFileUpload = (e, setFieldValue) => {
      const file = e.target.files[0];
  
      if (file) {
        // Check if file size exceeds 1MB
        const fileSizeInMB = file.size / 1024 / 1024;
        if (fileSizeInMB > 1) {
          setError("Please select an image smaller than 1MB.");
          setFieldValue("image", null);
          return;
        }
  
        // Clear error and set the file if size is valid
        setError("");
        setFieldValue("image", file);
      }
    };

    const buildSubcategoryFormData = (values) => {
      const formData = new FormData();

      formData.append("name", values.name || "");
      formData.append("category", values.category || "");
      formData.append("categoryType", values.categoryType || "");
      formData.append("sequence", values.sequence || "");
      formData.append("is_visible", values.is_visible);

      if (values.image instanceof File) {
        formData.append("image", values.image);
      }

      return formData;
    };
   
    const handleSubmit=async(values, {resetForm})=>{
      try {
        const payload = buildSubcategoryFormData(values);
        const createRes = currentItems?._id
          ? await SubCategoryApi.updateSubCategory(payload, currentItems?._id)
          : await SubCategoryApi.createSubCategory(payload);
        // console.log(createRes.data?.data);
        getAllData()
        toast.success(
          currentItems?._id ? "Subcategory updated" : "Subcategory created"
        );

      
      } catch (err) {
        // console.log(err);
        toast.error(err?.message);
      } finally {
        resetForm();        
        handleClose();
      }
    }  

    

    const getAllCategories = async () => {
        try {
           
            const res = await CategoryApi.getApproveCategory(categoryType);
            // console.log('res.data.data',res.data.data);
            
            setCategories(res.data.data); 
           
        } catch (error) {
            // console.log("error", error);           
        }
    };

 

  useEffect(() => {
    getAllCategories();
}, [categoryType]);

      if (open) {
        
          return (
            <div>
              <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                  validationSchema={subcategorySchema}
                >
                  {({ handleChange, values, handleSubmit, setFieldValue,resetForm }) => (
                    <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
                    <SidebarField
                      handleClose={handleClose}
                      title={currentItems?._id?`Update Subcategory`:`Add New Subcategory`}
                      button1={
                        <Button text="Cancel" type="button" onClick={handleClose} />
                      }
                      button2={<Button text={currentItems?._id?"Update":"Submit"} type="submit" onClick={()=>handleSubmit} />}                      
                    >
                        <FormField label="Subcategory Name" tooltip="enter your Subcategory name">
                          <div className="flex items-center">
                            <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                              EN
                            </span>
                            <TextInput
                              name="name"
                              type="text"
                              placeholder="Subcategory"
                              value={values.name}
                              onChange={handleChange}
                              required={true}
                            />
                          </div>
                          <ErrorMessage name="name" component="p" className="error" />
                        </FormField>
                        {/* image upload  */}
                        <div className="my-2">
                  {typeof values.image === "object" ? (
                    <ImagePreview file={values.image} id="image" />
                  ) : (
                    <LazyLoadImage
                      src={
                        values.image ||
                        "https://storeedelivery.elluminatiinc.net/assets/img/default_images/category.png"
                      }
                      alt="category-item"
                      effect="blur"
                      wrapperProps={{
                        style: { transitionDelay: "1s" },
                      }}
                    />
                  )}

                  <span className="text-[12px] text-gray-400  flex w-full">
                    <label htmlFor="image-upload" className="w-full flex ">
                      <TextInput
                        name="image"
                        type="file"
                        placeholder="Choose File"
                        id="image-upload"
                        onChange={(e) => handleFileUpload(e, setFieldValue)}
                      />
                      <button
                        className="border px-5 cursor-pointer z-5 "
                        type="file"
                        id="image-upload"
                      >
                        Browse
                      </button>
                    </label>
                  </span>
                  <ErrorMessage
                    name="image"
                    component="div"
                    className="error"
                  />
                </div>
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                        <FormField label="Category Type" tooltip="Choose Category Type">
                          <SelectDropdown
                              sx={{borderRadius:"3px",height:"2.6rem"}}
                              value={values.categoryType||""}
                              inputName="categoryType"
                              placeholder="Select Category Type"
                              options={[{name:'Ecommerce'},{name:'Food'}]}
                              optionLabel="name"
                              optionValue="name"
                              handleFilter={(name, v) => {
                                setCategoryType(v)
                                setFieldValue('categoryType', v);
                              }}
                          />
                        <ErrorMessage name="categoryType" component="p" className="error" />
                      </FormField>
                        <FormField
                            label="Category" 
                            tooltip="Select relevant category"
                        >                        
                          <SelectDropdown
                            sx={{borderRadius:"3px",height:"2.6rem"}}
                            value={values.category}
                            inputName="category"
                            placeholder="category"
                            optionLabel="name"
                            optionValue="_id"
                            options={categories||[]}
                            handleFilter={(name,v)=>{
                              // console.log(v);
                              setCategoryType()
                              setFieldValue('category',v)
                            }}
                          />
                          <ErrorMessage name="category" component="p" className="error" />
                        </FormField>       
                        <FormField
                          label="Sequence Number"
                          tooltip="enter your sequence number"
                        >
                          <TextInput
                            name="sequence"
                            type="number"
                            value={values.sequence}
                            onChange={handleChange}
                            required={true}
                          />
                               <ErrorMessage name="sequence" component="p" className="error" />
                        </FormField>                        
                        <div>
                        <ToggleField
                          text="Is category visible to user?"
                          name="is_visible"
                          value={values.is_visible}                          
                        />
                        <ErrorMessage name="is_visible" component="p" className="error" />
                        </div>
                    </SidebarField>
                    </Form>
                  )}
                </Formik>
            </div>
          )
      }
}

export default AddSubCategory
